import React, { memo } from 'react'
import { RouteComponentProps, useLocation } from '@reach/router'
import { useSiteMetadata } from '@hooks'
import { Children } from '@types'
import styles from './Page.module.scss'
import { Helmet } from 'react-helmet'

export interface PageProps extends RouteComponentProps {
  children: Children
}

const Page: React.FC<PageProps> = props => {
  const { children, path } = props
  const { navigation } = useSiteMetadata()
  const location = useLocation()

  const isDynamicPage = path!.includes('/*')
  const pathWithoutSlash = path!.slice(0, isDynamicPage ? -2 : -1)
  const page = navigation.find(page => page.path === pathWithoutSlash)

  return (
    <div className={styles.page} role="main">
      <Helmet>
        <meta
          name="description"
          content="Leading psychedelic therapeutics investment fund dedicated to increasing the global supply of clinically effective and accessible healthcare solutions"
        />
        <link rel="image_src" href="/assets/images/social.png" />
        <meta name="twitter:title" content="Palo Santo" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:description"
          content="Leading psychedelic therapeutics investment fund dedicated to increasing the global supply of clinically effective and accessible healthcare solutions"
        />
        <meta name="twitter:image" content="/assets/images/social.png" />
        <meta
          name="keywords"
          content="Eleusis, Bionomics, Atai Life Sciences, Field Trip Health, Bexson Biomedical, Psy Therapeutics, Diamond Therapeutics, Gilgamesh, Tactogen, Cybin, Wavepaths, Bright Minds, Awak, Double Blind, Psychedelic investment fund, Psychedelics, Palo Santo Fund, Ketamine, Psilocybin, MDMA, Microdosing, Psychedelic Therapeutics, Hunter Biden Toad Venom, Charles Nichols, Michael Pollan"
        />
      </Helmet>
      {children}
    </div>
  )
}

Page.defaultProps = {
  path: ''
}

export default memo(Page)
